import React, { useState } from "react";
import Dashboard from "../components/AdminDashboard";
import CustomHelmet from "../components/CustomHelmet";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import AdminBusinessOption from "../components/AdminBusinessOption";
const DashboardCategories = (props) => {
  const [business, setBusiness] = useState([
    "Fresh Food supplies Hub",
    "Catering and Restaurants Hub",
    "Automobile Services",
    "Baking Hub",
    "Hair products and Hair styling Hub",
    "Makeup Artist Hub",
    "Photography Hub",
    "Fabrics and Tailoring Hub",
    "Kids Fashion Hub",
    "Courier services Hub",
    "Event planners Hub",
    "Educational Services Hub",
    "Skincare Hub",
    "Freelancer Hub",
    "Art and Crafts Hub",
    "Books and Authors Hub",
    "Property and Accommodation Hub",
    "Laundry and Cleaning Services Hub",
  ]);
  const [service, setService] = useState("");
  function onRemove(id) {
    let newBusiness = business.filter((bus) => id !== bus);
    setBusiness(newBusiness);
  }
  function handleAdd() {
    if (service !== "") {
      setBusiness([service, ...business]);
      setService("");
    }
  }
  return (
    <>
      <CustomHelmet page="Admin Categories" />
      <Dashboard page="Categories">
        <Container className="my-3">
          <Row className="my-3">
            <Col md={6} sm={12}>
              <Form.Control
                value={service}
                onChange={(e) => setService(e.target.value)}
                type="text"
                placeholder="Business Category"
                className="mb-2"
              />
            </Col>
            <Col md={3} sm={12} className="d-flex justify-content-center">
              <Button variant="success" onClick={handleAdd}>
                Add Category
              </Button>
            </Col>
          </Row>
          {business.map((bus) => (
            <div key={bus} className="py-1">
              <AdminBusinessOption type={bus} onRemove={() => onRemove(bus)} />
            </div>
          ))}
          <Button variant="danger" size="lg" className="addbtn">
            Update
          </Button>
        </Container>
      </Dashboard>
    </>
  );
};
export default DashboardCategories;
